/* global require */

import { Vue2FiltersConfig } from "./configs/filter";
import Chart from "chart.js";
import Chartkick from "vue-chartkick";
import MainApp from "./components/App.vue";
import Router from "./router/index";
import Store from "./store/index";
import Vue from "vue";
import Vue2Filters from "vue2-filters";
import Vuetify from "vuetify";
import Booter from "./components/Booter.vue";
import VueSignaturePad from "vue-signature-pad";
import VueCryptojs from "vue-cryptojs";
import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {});
Vue.use(VueCryptojs);
Vue.config.productionTip = false;
Vue.use(VueSignaturePad);
Vue.use(Chartkick.use(Chart));
Vue.use(Vue2Filters, Vue2FiltersConfig);
Vue.use(Vuetify);

window.Event = new Vue();

if (window.location.pathname !== "/install.php") {
	require("./bootstrap");
	Store.dispatch("configs/initialize").then(() => {
		new Vue({
			el: "#app",
			components: { "main-app": MainApp },
			router: Router,
			store: Store,
			vuetify: new Vuetify(),
		});
	});
} else {
	new Vue({
		el: "#app",
		components: { "boot-app": Booter },
		vuetify: new Vuetify(),
	});
}
